import { create } from 'zustand';
import type { MondayUser } from '../api/monday.api';

// ─── Store ────────────────────────────────────────────────────────────────────

interface UsersState {
  /** All monday.com users in the account */
  users: MondayUser[];
  /** Whether users are currently loading */
  isLoading: boolean;
  /** Error message if the last fetch failed */
  error: string | null;

  // ─── Actions ──────────────────────────────────────────────────────────────

  setUsers: (users: MondayUser[]) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;

  /** Get a user by ID */
  getUserById: (id: number) => MondayUser | undefined;
  /** Get a map of userId -> user for quick lookups */
  getUserMap: () => Map<number, MondayUser>;
}

export const useUsersStore = create<UsersState>((set, get) => ({
  users: [],
  isLoading: false,
  error: null,

  setUsers: (users) => set({ users }),

  setLoading: (isLoading) => set({ isLoading }),

  setError: (error) => set({ error }),

  getUserById: (id) => {
    return get().users.find((u) => u.id === id);
  },

  getUserMap: () => {
    const map = new Map<number, MondayUser>();
    for (const user of get().users) {
      map.set(user.id, user);
    }
    return map;
  },
}));
